import { render, staticRenderFns } from "./VideoTemplate.vue?vue&type=template&id=0b76524a&scoped=true"
import script from "./VideoTemplate.vue.ts?vue&type=script&lang=ts&external"
export * from "./VideoTemplate.vue.ts?vue&type=script&lang=ts&external"
import style0 from "./VideoTemplate.vue?vue&type=style&index=0&id=0b76524a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b76524a",
  null
  
)

export default component.exports